import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import MeetTheTeam from "./sections/MeetTheTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStory />
      <MeetTheTeam />
      <Footer />
    </div>;
}